export default __webpack_public_path__ + "static/media/man-singing.5f15d48f.jpg";